import React, { useState, Fragment } from "react";
import Logo from "../assets/pandawa_logo.png";
import { Link } from "react-router-dom";
import { Menu, Transition } from "@headlessui/react";
import { Bars3Icon, XMarkIcon } from "@heroicons/react/24/outline";

const Navbar = () => {
  const [open, setOpen] = useState(false);
  return (
    <>
      <div className="sticky top-0 z-50 h-10 sm:h-16 bg-primaryPandawa flex items-center justify-center py-10">
        <section className="flex container-screen items-center ">
          <div className="flex mr-auto items-center">
            <div className="sm:h-10 sm:w-10 h-7 w-7">
              <img src={Logo} alt="Logo" />
            </div>
            <p className="ml-3 sm:text-xl font-helios text-xs text-white">
              PT Pandawa Jaya Steel
            </p>
          </div>

          {/* Desktop Menu */}
          <div className="sm:flex items-center hidden">
            <Link to="/">
              <p className="header-font">Home</p>
            </Link>
            <Link to="/about-us">
              <p className="header-font">About Us</p>
            </Link>
            <Link to="/product">
              <button className="header-font">Products</button>
            </Link>
            <Link to="/karir">
              <button className="header-font">Career</button>
            </Link>
            <Link to="/hubungi-kami">
              <p className="header-font">Contact</p>
            </Link>

            {/* Desktop Social Media Icons - Improved Hierarchy */}
            <div className="flex items-center ml-8 gap-3 pl-8 border-l-2 border-white/50">
              <Link
                to="https://www.instagram.com/pt.pandawajayasteel/"
                target="_blank"
                rel="noopener noreferrer"
                className="transition-opacity"
              >
                <svg
                  className="h-4 w-4 text-white opacity-80 hover:opacity-100 transition-opacity"
                  fill="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" />
                </svg>
              </Link>

              <Link
                to="https://www.tiktok.com/@pt.pandawajayaste?_r=1&_t=ZS-91O7ko3QGRc"
                target="_blank"
                rel="noopener noreferrer"
                className="transition-opacity"
              >
                <svg
                  className="h-4 w-4 text-white opacity-80 hover:opacity-100 transition-opacity"
                  fill="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z" />
                </svg>
              </Link>

              <Link
                to="https://www.linkedin.com/company/ptpandawajayasteel/"
                target="_blank"
                rel="noopener noreferrer"
                className="transition-opacity"
              >
                <svg
                  className="h-4 w-4 text-white opacity-80 hover:opacity-100 transition-opacity"
                  fill="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
                </svg>
              </Link>
            </div>
          </div>

          {/* Mobile Menu Button */}
          <div>
            {open ? (
              <XMarkIcon
                className="relative w-7 h-7 sm:hidden text-white cursor-pointer transition z-50"
                onClick={() => setOpen(!open)}
              />
            ) : (
              <Bars3Icon
                className="relative w-7 h-7 sm:hidden text-white cursor-pointer transition"
                onClick={() => setOpen(!open)}
              />
            )}

            {/* Overlay */}
            {open && (
              <div
                className="fixed inset-0 bg-black bg-opacity-50 sm:hidden z-40"
                onClick={() => setOpen(false)}
              />
            )}

            {/* Sidebar Menu */}
            <div
              className={`fixed top-0 left-0 h-full w-64 bg-white shadow-2xl transform transition-transform duration-300 ease-in-out sm:hidden z-40 ${
                open ? "translate-x-0" : "-translate-x-full"
              }`}
            >
              <div className="py-6 flex flex-col h-full">
                {/* Logo di dalam sidebar */}
                <div className="flex items-center px-6 mb-8">
                  <div className="h-8 w-8">
                    <img src={Logo} alt="Logo" />
                  </div>
                  <p className="ml-3 font-helios text-xs text-primaryPandawa">
                    PT Pandawa Jaya Steel
                  </p>
                </div>

                {/* Menu Items */}
                <div className="flex-1">
                  <Link to="/" onClick={() => setOpen(false)}>
                    <p className="font-montserrat text-left px-6 py-3 hover:bg-primaryPandawa hover:text-white transition-colors text-primaryPandawa">
                      Home
                    </p>
                  </Link>
                  <Link to="/about-us" onClick={() => setOpen(false)}>
                    <p className="font-montserrat text-left px-6 py-3 hover:bg-primaryPandawa hover:text-white transition-colors text-primaryPandawa">
                      About Us
                    </p>
                  </Link>
                  <Link to="/product" onClick={() => setOpen(false)}>
                    <p className="font-montserrat text-left px-6 py-3 hover:bg-primaryPandawa hover:text-white transition-colors text-primaryPandawa">
                      Products
                    </p>
                  </Link>
                  <Link to="/karir" onClick={() => setOpen(false)}>
                    <p className="font-montserrat text-left px-6 py-3 hover:bg-primaryPandawa hover:text-white transition-colors text-primaryPandawa">
                      Career
                    </p>
                  </Link>
                  <Link to="/hubungi-kami" onClick={() => setOpen(false)}>
                    <p className="font-montserrat text-left px-6 py-3 hover:bg-primaryPandawa hover:text-white transition-colors text-primaryPandawa">
                      Contact
                    </p>
                  </Link>
                </div>

                {/* Social Media Icons */}
                <div className="px-6 py-4 border-t border-gray-200">
                  <div className="flex gap-4 justify-center">
                    <Link
                      to="https://www.instagram.com/pt.pandawajayasteel/"
                      target="_blank"
                      rel="noopener noreferrer"
                      onClick={() => setOpen(false)}
                    >
                      <svg
                        className="h-6 w-6 text-primaryPandawa hover:opacity-70 transition-opacity"
                        fill="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" />
                      </svg>
                    </Link>

                    <Link
                      to="https://www.tiktok.com/@pt.pandawajayaste?_r=1&_t=ZS-91O7ko3QGRc"
                      target="_blank"
                      rel="noopener noreferrer"
                      onClick={() => setOpen(false)}
                    >
                      <svg
                        className="h-6 w-6 text-primaryPandawa hover:opacity-70 transition-opacity"
                        fill="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z" />
                      </svg>
                    </Link>

                    <Link
                      to="https://www.linkedin.com/company/ptpandawajayasteel/"
                      target="_blank"
                      rel="noopener noreferrer"
                      onClick={() => setOpen(false)}
                    >
                      <svg
                        className="h-6 w-6 text-primaryPandawa hover:opacity-70 transition-opacity"
                        fill="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
                      </svg>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default Navbar;
